import React from 'react'
import styled from 'styled-components'
import { Heading, Text } from 'rebass'

export default styled(({h1, h2, h3, h4, h5, h6, bold, error, primary, secondary, center, light, ...others}) =>
  h1 || h2 || h3 || h4 || h5 || h6
    ? <Heading is={(h1 && 'h1') || (h2 && 'h2') || (h3 && 'h3') || (h4 && 'h4') || (h5 && 'h5') || (h6 && 'h6')} {...others} />
    : <Text {...others} />
)`
  font-weight: ${props => props.bold ? props.theme.fontWeights.bold : props.theme.fontWeights.normal};
  color: ${props => props.theme.colors.text};
  ${props => props.error ? `color: ${props.theme.colors.error};` : ''}
  ${props => props.primary ? `color: ${props.theme.colors.primary};` : ''}
  ${props => props.secondary ? `color: ${props.theme.colors.secondary};` : ''}
  ${props => props.light ? `color: ${props.theme.colors.lightText};` : ''}
  ${props => props.center ? `text-align: center` : ''}
`


// WEBPACK FOOTER //
// ./src/components/Text.js